import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {FaAngleDoubleLeft, FaAngleDoubleRight, FaWheelchair, FaPen} from 'react-icons/fa';
import {
    fetchEmployee,
    fetchEmployeeDependents,
    fetchDeleteEmployeeDependent
} from '../../actions/EmployeeActions';
import { fetchUpdatePackageProgress } from '../../actions/EnrollmentActions';
import { ContentCard } from '../Cards';
import DeleteConfirm from '../DeleteConfirm/DeleteConfirm';
import { stepNumberHelper } from '../../utils/StepNumberHelper';
import { userService } from '../../utils/UserService';
import { formatDate } from '../../utils/ViewHelper';
import { renderGender } from './EmployeeHelper';
import { Button, Table } from 'react-bootstrap';
import { PackageStepType } from '../../types/api/enrollmentPackages/Package';

class EmployeeDependentList extends Component {
    state = {
        personId: null
    };

    componentDidMount() {
        userService
            .currentPersonId()
            .then(personId => {
                this.setState({
                    personId: personId
                }, () => {
                    if (this.props.packageId) {
                        this.props.fetchEmployee(personId, this.props.packageId).then(employee => {
                            if(employee && employee.personId === parseInt(personId, 10)) {
                                this.props.fetchEmployeeDependents(personId, employee.groupId, this.props.packageId);
                            }
                        });
                    }
                });
            });
    }

    onAddDependentChild = () => {
        this.props.history.push(`/packages/${this.props.packageId}/dependents-addchild`);
    };

    onAddDependentSpouse = () => {
        this.props.history.push(`/packages/${this.props.packageId}/dependents-addspouse`);
    };

    onBack = e => {
        this.props.history.push(`/packages/${this.props.packageId}/employee`);
    };

    onContinue = async () => {
        if (!this.props.packageId) {
            return;
        }

        const activePackage = this.props.activePackage;
        const currentStepNumber = stepNumberHelper.stepNumberForNamedStep(activePackage, PackageStepType.Dependents);

        await this.props.fetchUpdatePackageProgress(this.props.packageId, currentStepNumber, true);

        const nextStep = stepNumberHelper.getNextStep(activePackage, currentStepNumber);

        // This is a little hacky.
        // Basically: Check for the next step. If the next step has an entity id,
        // we are assuming it's a dynamic step that we can route to.
        // If it's not a dynamic step, we will hard code in a route to insurability.
        if (nextStep) {
            // Route to a dynamic step.
            if(nextStep.harmonyProductGroup) {
                this.props.history.push(`/packages/${this.props.packageId}/harmony/${nextStep.harmonyProductGroup}`);
            } else if (nextStep.relatedEntityId) {
                this.props.history.push(`/packages/${this.props.packageId}/plantypes/${nextStep.relatedEntityId}`);
            } else if (nextStep.type === PackageStepType.DocumentUpload) {
                this.props.history.push(`/packages/${this.props.packageId}/documents`);
            }
            else {
                this.props.history.push(`/packages/${this.props.packageId}/summary`);
            }
        }
    };

    renderDependents = (dependents) => {
        return dependents.map((dependent, key) => {
            return (
                <tr key={key}>
                    <td>
                        <Link to={`/packages/${this.props.packageId}/dependents/${dependent.personId}`}>{dependent.name}</Link>
                        &nbsp;&nbsp;{dependent.isDisabled && (<FaWheelchair />)}
                    </td>
                    <td>{dependent.relationshipTypeLabel}</td>
                    <td>{dependent.usSocialSecurityNumber}</td>
                    <td>{formatDate(dependent.dateOfBirth)}</td>
                    <td>{renderGender(dependent.gender)}</td>
                    <td className="text-center">
                        <Link to={`/packages/${this.props.packageId}/dependents/${dependent.personId}`} className="mr-4 btn btn-sm btn-primary"><FaPen /> Modify</Link>

                        {dependent.terminateDate === null ?
                            <DeleteConfirm onDeleteClick={e => this.props.history.push(`/packages/${this.props.packageId}/dependents/${dependent.personId}/delete`)} />
                            : <span>Relationship Ended</span>}
                    </td>
                </tr>
            );
        });
    };

    render() {
        const { employeeDependentsList, loading, error } = this.props;
        const { item: employee } = this.props.activeEmployee;
        const employeeId = this.state.personId;

        const alreadyHasSpouse = employeeDependentsList.items.find(dependent => dependent.relationshipTypeLabel === 'Spouse' || dependent.relationshipTypeLabel === 'Domestic Partner') !== undefined;

        return (
            employeeDependentsList && employee && employee.personId === parseInt(employeeId, 10) ?
                <ContentCard loading={loading} error={error}>
                    <div>
                        <div className="float-right">
                            {!alreadyHasSpouse ? <Button type="button" size="sm" variant="primary" onClick={this.onAddDependentSpouse} className="mr-2">Add Spouse/DP</Button> : null}
                            <Button type="button" size="sm" variant="primary" onClick={this.onAddDependentChild}>Add Child</Button>
                        </div>
                        <h2>Dependents</h2>
                        <br />
                        <span>Please add all eligible dependents, even if you won&apos;t be enrolling them in coverage.  You will be able to choose which dependents you want to cover when making your policy selections.</span>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Relationship</th>
                                    <th>SSN</th>
                                    <th>DOB</th>
                                    <th>Gender</th>
                                    <th style={{ minWidth: '159px'}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderDependents(employeeDependentsList.items)}
                            </tbody>
                        </Table>
                    </div>

                    <div>
                        <button type="button" className="btn btn-default mr-2" onClick={e => this.onBack(e)}><FaAngleDoubleLeft />Back</button>
                        <button type="submit" className="btn btn-primary float-right" disabled={!this.props.activePackage} onClick={e => this.onContinue()}>Continue <FaAngleDoubleRight /></button>
                    </div>
                </ContentCard>
                : <div />
        );
    }

}

const mapStateToProps = (state) => {
    return {
        activeEmployee: state.employees.activeEmployee,
        activePackage: state.packages.activePackage.data,
        employeeDependentsList: state.employeeDependents.employeeDependentsList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteEmployeeDependent: (dependentId, employeeId, groupId) => {
            return dispatch(fetchDeleteEmployeeDependent(dependentId, employeeId, groupId));
        },
        fetchEmployee: (employeeId, packageId) => {
            return dispatch(fetchEmployee(employeeId, packageId));
        },
        fetchEmployeeDependents: (employeeId, groupId, packageId) => {
            return dispatch(fetchEmployeeDependents(employeeId, groupId, packageId));
        },
        fetchUpdatePackageProgress: (packageId, stepNumber, updateSteps) => {
            return dispatch(fetchUpdatePackageProgress(packageId, stepNumber, updateSteps));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmployeeDependentList));